import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

const container = { hidden: {}, show: { transition: { staggerChildren: 0.12 } } };
const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export function HowItWorks() {
  const { t, dict } = useI18n();
  const steps = dict.how.steps;

  return (
    <section id="como-funciona" className="relative py-20 lg:py-32 border-t border-slate-800/70 bg-[#0F172A]" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-emerald-500" />
            <p className="eyebrow">{t("how.eyebrow")}</p>
          </div>
          <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05]">
            {t("how.heading")}
          </h2>
          <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed">{t("how.p1")}</p>
          <p className="mt-4 text-base sm:text-lg text-slate-300 leading-relaxed">{t("how.p2")}</p>
        </div>

        <motion.ol
          className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          variants={container}
        >
          {steps.map((s, i) => (
            <motion.li
              key={s.n}
              variants={item}
              className="z-card p-6 lg:p-7 relative overflow-hidden group"
              data-testid={`how-step-${i + 1}`}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-mono text-xs uppercase tracking-widest text-emerald-400">Paso {s.n}</span>
                <span className="font-display text-4xl font-light text-slate-700 group-hover:text-emerald-500/70 transition-colors">
                  {s.n}
                </span>
              </div>
              <h3 className="font-display text-xl font-semibold text-white">{s.title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
              <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-emerald-500 transition-all duration-500 group-hover:w-full" />
            </motion.li>
          ))}
        </motion.ol>
      </div>
    </section>
  );
}

export default HowItWorks;
